import { useState } from 'preact/hooks'
import { FieldLabel } from './FieldLabel'

export const FieldPrefixOptions = ({ props }) => {
  return (
    <div className={'flex-shrink-0 border-r border-solid'}>
      <div className={'m-auto flex h-full w-fit max-w-24  items-center justify-center'}>
        <select className={'h-full w-full border-none outline-none'} onChange={props.handleSelectedPrefix}>
          {props.options.map((option) => {
            return (
              <option value={option.value} selected={option.value === props.selectPrefix}>
                {option.value}
              </option>
            )
          })}
        </select>
      </div>
    </div>
  )
}

export const FieldPrefix = ({ type = '', name, required, value, label, onChange, readOnly, prefix, error, placeholder }) => {
  const [isFocused, setIsFocused] = useState(false)
  const [selectPrefix, setSelectPrefix] = useState(prefix?.options[0] ?? undefined)
  const handleSelectedPrefix = (e) => {
    const { value } = e.currentTarget
    setSelectPrefix(value)
  }

  const handleBlur = (e) => {
    const { value } = e.currentTarget
    if (value) {
      // If value starts with 04, remove the 04 and set the prefix to +61
      if (value.startsWith('04') && value.length === 10) {
        const newValue = value.replace('04', '4')
        e.currentTarget.value = newValue
        onChange(e)
      }
      if (value.startsWith('+614') && value.length === 12) {
        const newValue = value.replace('+614', '4')
        e.currentTarget.value = newValue
        onChange(e)
      }
    }
  }
  if (!prefix || !prefix?.options || !prefix.options.length) return <></>
  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel {...{ label, hasInput: !!value, required }} />
      <div
        className={`relative inline-flex overflow-hidden rounded-lg border border-solid border-neutrals-tertiary-grey bg-primary-white transition-colors
          ${isFocused || !!value ? 'border-2 border-secondary-green' : 'border-neutrals-tertiary-grey'}`}
      >
        <FieldPrefixOptions
          props={{ selectPrefix: selectPrefix.value, handleSelectedPrefix, options: prefix?.options ?? [] }}
        />
        <input
          onFocus={() => {
            setIsFocused(true)
          }}
          onBlur={(e) => {
            setIsFocused(false)
            handleBlur(e)
          }}
          className={
            'min-h-12 w-full grow border-none px-4 pl-4 read-only:cursor-default read-only:text-neutrals-secondary-grey read-only:opacity-60'
          }
          {...(type && { type })}
          readOnly={readOnly}
          required={required}
          name={name}
          value={value}
          pattern={selectPrefix.pattern}
          onChange={onChange}
          placeholder={placeholder}
        />
        <input type={'hidden'} name={name} value={selectPrefix.value.concat(value)} />
      </div>
      {/* <FieldBanner
          props={{
            icon: 'information-xs',
            content: 'This is a test input test '
          }}
        /> */}
      {!!error && <div className={'paragraph-sm text-system-error font-medium'}>{error}</div>}
    </div>
  )
}
